import { proxy } from 'valtio'
import { TenantConfig } from '@app/graphql'

const initialState: TenantConfig = {
  tenantId: '',
  branding: null,
  featureFlags: [],
  demoProfileId: null,
  integrationConfig: null,
  integrationSecrets: null,
}

export const TenantConfigState = proxy<TenantConfig>(initialState)
